module.exports = __webpack_public_path__ + "static/media/4.20.5eee20db.png";